import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPaywallsModalsV3 } from "@/react/hooks/useIsPaywallsModalsV3";

interface TabContainerProps {
  className?: string;
}

export const TabContainer = ({
  children,
  className,
}: PropsWithChildren<TabContainerProps>) => {
  const isPaywallsModalsV3 = useIsPaywallsModalsV3();

  return (
    <div
      className={classNames(
        {
          "flex flex-col gap-y-8 px-5 py-6 md:px-0 md:py-12":
            isPaywallsModalsV3,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
